import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-last-candidates',
  templateUrl: './last-candidates.component.html',
  styleUrls: ['./last-candidates.component.css']
})
export class LastCandidatesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/last-candidates/last-candidates.component.ts